import React, { createContext, useContext, useState } from "react";
import EdgeDrawer from "./ui/EdgeDrawer";
import { brandedMaturaPdfUrl } from "../utils/maturaPdfUrl";

// Original-task pages supply one shared pair of PDF links outside the rendered task.
export const MaturaPdfPreviewEnabledContext = createContext(true);

export default function MaturaPdfPreview({ url, title, label = "Otwórz PDF obok zadania" }) {
  const [open, setOpen] = useState(false);
  const enabled = useContext(MaturaPdfPreviewEnabledContext);
  const previewUrl = brandedMaturaPdfUrl(url);
  if (!enabled) return null;
  return <>
    <button type="button" className="btn-secondary" onClick={() => setOpen(true)}>{label}</button>
    {open && <EdgeDrawer side="right" isOpen={open} onOpenChange={setOpen} width="min(850px, 96vw)"
      contentMaxWidth="100%" title={title} bodyOverflow="hidden" contentPadding={0} zIndex={21000}
      headerRight={<a className="btn-secondary" href={previewUrl} target="_blank" rel="noopener noreferrer">Otwórz w nowej karcie ↗</a>}>
      {open && <iframe title={title} src={previewUrl} style={{ width: "100%", height: "100%", minHeight: "75vh", border: 0 }} />}
    </EdgeDrawer>}
  </>;
}
